export default __webpack_public_path__ + "static/media/trending_sell.033505ab.png";